<template>
<div id="app" class='noprint'>
  <div v-if="$store.state.init_state === 'created'" class='init'>
    <div>
      <img src="/files/imgs/loading.svg" /><br />
      Initializing...
    </div>
  </div>
  <div v-else-if="$store.state.init_state === 'error'">
    Failed to load
  </div>
  <div v-else class='app1'>
    <div v-if="$store.state.init_state === 'notLoggedIn'" class='login'>
      <login></login>
    </div>
    <div v-if='$store.state.user && $store.state.init_state == "ready"' class='app2'>
      <drawer></drawer>
      <div id="nav">
	<div class='logo'>
	  <img src="./assets/logo2.png" />
	</div>
	<div class='header'>
	  <mainmenu name='entity' :cover="$store.getters.entity.name" select='entities' :parent='null' />
	  <mainmenu name='host' :cover="$store.getters.host.name" select='hosts' parent='entity' :parent_id='$store.state.context.entity_id' :watch='$store.state.context.entity_id' />
	  <mainmenu name='race' :cover="$store.getters.race.name" select='races' parent='host' :parent_id='$store.state.context.host_id' :watch='$store.state.context.host_id' />
	</div>
	<div class='icon hamburger' @click="$store.commit('showDrawer', true)">
	  <img src="./assets/icons/menu.svg" />
	</div>
      </div>
      <div v-if="$store.getters.menu_heir($route)" class='menu2'>
	<div style='display: flex; align-items: center'>
	  <router-link v-if="$store.getters.menu_parent_item($route)" :to="$store.getters.menu_url($store.getters.menu_parent_item($route))">
	      <img style='height: 1em; padding: 0 10px 0 0;' src="./assets/icons/back.svg" />
	  </router-link>
	  <div>
	    {{$store.getters.menu_heir($route)}}:
	  </div>
	</div>
	<div v-for="menu in $store.state.data.menus[$store.getters.menu_heir($route)]"  v-if="$store.getters.menu_check_perm(menu.perms)">
	  <router-link :class="{active: $route.path===menu.url}" :to="$store.getters.menu_url(menu)">{{menu.name}}</router-link>
	</div>
      </div>
      <!--<ul v-for="menu,k in $store.state.data.menus">
        <li>{{k}}
          <ul v-for='item in menu'>
            <li>{{menu}}</li>
          </ul>
        </li>
      </ul>-->
      <router-view :key="$route.fullPath" />
    </div>
  </div>
  <error :show="$store.state.error.show" :msg="$store.state.error.msg" @close="$store.commit('setError',{show:false,msg:''})"></error>
  <loading :show="$store.state.loading.show" :msg="$store.state.loading.msg"></loading>
</div>
</template>

<script>
import Loading from './components/Loading.vue'
import Error from './components/Error.vue'
import Drawer from './components/Drawer.vue'
import Mainmenu from './components/Mainmenu.vue'
import Login from './components/Login.vue'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    data: function() { return {
    }},
    methods: {
        setEntityId: function(e) {
            this.$store.commit('setEntityId', e.target.value)            
        }
    },
    computed: {
        ...mapState({
            // arrow functions can make the code very succinct!
            entity_id: state => state.entity_id
        }),
        ...mapGetters(['entity'])
    },
    components: { Loading, Error, Drawer, Mainmenu, Login }
}
</script>

<style>
#nav {
    display: flex;
}
#nav .mid {
    flex-grow: 1;
    text-align: center;
}
.left, .mid, .right {
    padding: 10px;
}

.entity_menu {
    
}
.logo {
    flex-grow: 0;
    margin-top: 5px;
    margin-right: 10px;
}
.hamburger {
    flex-grow: 0;
}
.header {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
}
.menu2 {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #444;
    flex-wrap: wrap;
    align-items: center;
}
.menu2 > div {
    padding: 0 10px;
    border-right: 1px solid #444;
    margin: 5px 0;
}
.menu2 > div:last-child {
    border-right: 0;
}
.menu2 > div:first-child {
    color: #666;
    text-transform: uppercase;
    border-right: 0;
}
.menu2 a {
    color: #444;
    text-decoration: none;
}

.menu2 a.active {
    font-weight: bold;
}
.top {
    box-shadow: 0 0 5px rgba(0,0,0,0.5);
}
.init {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
</style>
